import SweetAlert from "src/class/Alerts";
import alert from "sweetalert2";
import axios from "axios";
import i18n from "../i18n";

const MixinExport = {
  methods: {
    /**
     * este metodo se encarga de hacer la peticion a la api
     * para obtener el archivo en pdf con todos los maestros,
     * ademas crea un enlace y lo ejecuta para empezar la descarga
     * @param {*} data
     * @param {String} paramMethod
     * @param {Boolean} request
     * @return {VoidFunction}
     */
    PDF(data, paramMethod = "GET", request = false) {
      SweetAlert.download(
        i18n.t('mix.mixin_export.wait_while_pdf_downloads'),
        alert
      );

      let response;
      if (request) {
        response = axios({
          url: "/auth/" + data.route,
          method: paramMethod,
          data: data,
          responseType: "blob"
        });
      } else {
        response = axios({
          url: "/auth/" + data.route,
          method: paramMethod,
          responseType: "blob"
        });
      }

      return response.then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", data.name_file);
        document.body.appendChild(link);
        link.click();
        alert.close();
      });
    },

    /**
     * esta accion se encarga de hacer la peticion a la api
     * para obtener el archivo en excel con todos los maestros,
     * ademas crea un enlace y lo ejecuta para empezar la descarga
     * @param {*} data
     * @param {String} paramMethod
     * @param {Boolean} request
     * @return {VoidFunction}
     */
    Excel(data, paramMethod = "GET", request = false) {
      SweetAlert.download(
        i18n.t('mix.mixin_export.wait_while_excel_downloads'),
        alert
      );

      let response;
      if (request) {
        response = axios({
          url: "/auth/" + data.route,
          method: paramMethod,
          data: data,
          responseType: "blob"
        });
      } else {
        response = axios({
          url: "/auth/" + data.route,
          method: paramMethod,
          responseType: "blob"
        });
      }

      return response.then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", data.name_file);
        document.body.appendChild(link);
        link.click();
        alert.close();
      });
    },

    async createFile(obj) {
      let response = await fetch(obj.url, { mode: "no-cors" });
      let data = await response.blob();
      let metadata = {
        type: "application/vnd.google-earth.kml+xml"
      };

      return new File([data], obj.name + "." + obj.extension, metadata);
    }
  }
};

export { MixinExport };
